export enum LocalStorageVariables {
	CART = 'cart',
	ACCESS_TOKEN = 'accessToken',
}
